const actions = {
  // 登录凭证
  sessionId ({ commit }, status) {
    commit('sessionId', status)
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/vue/vuex/actions.js